const pageVariants = {
  initial: {
    opacity: 0,
    x: 0,
    y: 100,
    scale: 1,
  },
  in: {
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    x: 0,
    y: 100,
    scale: 1,
  },
};

const fadePages = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 1,
};

export { pageVariants, pageTransition, fadePages };
